import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { Grid, Input } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import Errordialog from '../../errordialog';

class Add extends React.Component {
  state = {
    open: false,
  };


  addDetails() {
    let context = this;
    let name = document.getElementById('name').value;
    let account = document.getElementById('account').value;
    let ifsc = document.getElementById('ifsc').value;
    let payee = document.getElementById('payee').value;
    if (name == '' || name == undefined || name == null) {
      alert('Enter the Bank Name!!!');
      return;
    }
    if (account == '' || account == undefined || account == null) {
      alert('Enter the ACCOUNT NUMBER!!!');
      return;
    }
    if (ifsc == '' || ifsc == undefined || ifsc == null) {
      alert('Enter the IFSC CODE!!!');
      return;
    }
    if (payee == '' || payee == undefined || payee == null) {
      alert('Enter the Payee Name!!!');
      return;
    }
    let data = { 'name': name, 'account': account, 'ifsc': ifsc, 'payee': payee };
    context.setState({
      load: true,
      message: 'Adding Bank Details'
    })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'bankdetails/add.php',
      success: function(data)
      {
        if (data == 1) {
          context.setState({
            load: false,
          })
          context.props.updateDatas(data);
        }
        else {
          context.setState({ load: false, errorDialog: true, errormessage: 'Failed to Add!!!' })
        }
      },
      error: function(e)
      {
        alert('Try again!!!');
        context.setState({
          load: false,
        })
      }
    });
  }

  closeErrorDialog() {
    this.setState({ errorDialog: false });
  }

  render() {
    const { fullScreen } = this.props;
    const { load, message } = this.state;
    return (
      <div>
        <Dialog fullScreen={fullScreen} open={this.props.open}
         onClose={this.handleClose} aria-labelledby="responsive-dialog-title">
          <DialogTitle id="responsive-dialog-title" style={{width: 500}}>{"Add Bank Details"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Errordialog load={this.state.errorDialog} message={this.state.errormessage} close={this.closeErrorDialog.bind(this)} />
              <Loading load={load} message={message} />
              <Grid fluid>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Input id='name' focus placeholder='Bank Name' style={{ borderColor: '#5A9CBB' }} fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                <Input id='account' focus placeholder='Account Number' style={{ borderColor: '#5A9CBB' }} fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                <Input id='ifsc' focus placeholder='IFSC CODE' style={{ borderColor: '#5A9CBB' }} fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Input id='payee' focus placeholder='Payee Name' style={{ borderColor: '#5A9CBB' }} fluid />
                </Grid.Column>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.closeAdd} color="black">
              Cancel
            </Button>
            <Button onClick={this.addDetails.bind(this)} color="primary" autoFocus>
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Add.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(Add);
